<div class="modal-header">
  <h3 class="modal-title">Artikel details</h3>
</div>
<div class="modal-body">
  <app-article-source-response [response]="response"></app-article-source-response>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">Sluiten</button>
</div>
